














import { BButton, BPopover } from "bootstrap-vue";

export default {
    components: {
        BPopover,
        BButton,
    },
    props: {
        target: {
            type: String,
            requeired: true,
        },
        placement: {
            type: String,
            requeired: true,
        },
        header: {
            type: String,
            requeired: true,
        },
        intro1: {
            type: String,
            requeired: true,
        },
    },
    data() {
        return {
            popoverShow: false,
        };
    },
    methods: {
        onPopoverClose() {
            // @ts-ignore
            this.popoverShow = false;
        },
    },
};
